export default __webpack_public_path__ + "static/media/AE16.190ae72e.jpg";